module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik04IDJMMTAuMDA4NiA1Ljk1MDE2TDE0LjUgNi41ODM1OUwxMS4yNSA5LjY1ODM2TDEyLjAxNzIgMTRMOCAxMS45NTAyTDMuOTgyNzggMTRMNC43NSA5LjY1ODM2TDEuNSA2LjU4MzU5TDUuOTkxMzkgNS45NTAxNkw4IDJaIiBmaWxsPSIjRkZEMzI0Ii8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/appStore/collect_active.svg
// module id = wNix
// module chunks = 4